module.exports = __webpack_public_path__ + "img/Rich_Morris@3x.89935d07.png";